// src/components/FormikSelect.js

import React from "react"
import { FormGroup, Label, Input, FormFeedback } from "reactstrap"

const FromikSelect = ({
  label,
  name,
  options,
  formik,
  placeholder = "Selecciona...",
  valuePlaceHolder = -1,
  parseValue = true,
  onChange: customOnChange, // aquí recibimos la función personalizada
  ...props
}) => {
  //
  // Si le pasamos la propiedad personalizada onChange
  // se ejecuta en lugar de actualizar el valor en el campo forik
  // siempre debemos actualizar el valor en la última linea
  // de la función personalizada
  // formik.setFieldValue(name, value)
  const handleChange = e => {
    let value = e.target.value
    if (parseValue) {
      value = Number(value)
    }
    if (typeof customOnChange === "function") {
      // Se usa la función personalizada si existe
      customOnChange(e, value)
    } else {
      // Caso contrario, se actualiza el valor en Formik
      formik.setFieldValue(name, value)
    }
  }

  return (
    <FormGroup>
      <Label htmlFor={name}>{label}</Label>
      <Input
        type="select"
        name={name}
        id={name}
        value={formik.values[name]}
        onChange={handleChange}
        onBlur={formik.handleBlur}
        invalid={formik.touched[name] && !!formik.errors[name]}
        {...props}
      >
        <option value={valuePlaceHolder} disabled>
          {placeholder}
        </option>
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Input>
      {formik.touched[name] && formik.errors[name] && (
        <FormFeedback>{formik.errors[name]}</FormFeedback>
      )}
    </FormGroup>
  )
}

export default FromikSelect
